import { HiClock, HiArrowTopRightOnSquare } from "react-icons/hi2";
import {
  ResultStatusIcon,
  SummaryRow,
  TransactionDetailsCard,
} from "../../../shared/result/ResultPrimitives";
import {
  formatDateTimeToLocale,
  formatKES,
} from "../../../../utils/transactionutils";
import { contactSupport } from "../../../../utils/supportUtils";
import CustomButton from "../../../ui/CustomButton/CustomButton";
import CustomNotificationBanner from "../../../ui/CustomNotificationBanner/CustomNotificationBanner";

export function ProcessingView({
  amount,
  transactionId,
  createdDate,
  transactionFee,
  totalDeducted,
  newBalance,
  onViewTransactions,
}) {
  return (
    <div className="flex flex-col items-center gap-6">
      <div className="flex flex-col items-center text-center gap-3">
        <ResultStatusIcon
          icon={HiClock}
          bgClassName="bg-amber-50"
          iconClassName="text-amber-500"
        />
        <div className="space-y-1">
          <p className="text-sm sm:text-base font-semibold text-amber-600">
            Withdrawal Processing
          </p>
          <p className="text-xs sm:text-sm text-gray-500 max-w-xs">
            We couldn&apos;t confirm your withdrawal status. The payout is still
            processing on the network.
          </p>
        </div>
      </div>

      <div className="w-full">
        <CustomNotificationBanner
          variant="warning"
          title="Status: Processing"
          message="Please check your transaction history for the latest status before retrying."
          withCloseButton={false}
        />
      </div>

      <TransactionDetailsCard>
        {transactionId && (
          <SummaryRow label="Transaction ID" value={transactionId} stacked />
        )}
        {createdDate && (
          <SummaryRow
            label="Date"
            value={formatDateTimeToLocale(createdDate)}
          />
        )}
        <SummaryRow label="Amount" value={formatKES(amount)} />
        <SummaryRow label="Transaction Fee" value={formatKES(transactionFee)} />
        <SummaryRow
          label="Total Deducted"
          value={formatKES(totalDeducted)}
          bold
        />
        <SummaryRow label="New Balance" value={formatKES(newBalance)} />
      </TransactionDetailsCard>

      <div className="w-full max-w-sm sm:max-w-md mx-auto grid grid-cols-1 xs:grid-cols-2 gap-2">
        <CustomButton
          fullWidth
          color="primary"
          radius="md"
          leftSection={<HiArrowTopRightOnSquare style={{ fontSize: 14 }} />}
          onClick={onViewTransactions}
        >
          View in Transactions
        </CustomButton>
        <CustomButton
          fullWidth
          variant="outline"
          color="gray"
          radius="md"
          onClick={() => contactSupport()}
        >
          Contact Support
        </CustomButton>
      </div>
    </div>
  );
}
